import { LegalPage } from '@/components/LegalPage';
import { terminos } from '@/legal/docs/terminos';
import { privacidad } from '@/legal/docs/privacidad';
import { articulosProhibidos } from '@/legal/docs/articulos_prohibidos';
import { comunidad } from '@/legal/docs/comunidad';
import { dmca } from '@/legal/docs/dmca';
import { cookies } from '@/legal/docs/cookies';
import { privacidadEstatal } from '@/legal/docs/privacidad_estatal';

export function Terminos() {
  return <LegalPage doc={terminos} />;
}

export function Privacidad() {
  return <LegalPage doc={privacidad} />;
}

export function ArticulosProhibidos() {
  return <LegalPage doc={articulosProhibidos} />;
}

export function Comunidad() {
  return <LegalPage doc={comunidad} />;
}

export function Dmca() {
  return <LegalPage doc={dmca} />;
}

export function Cookies() {
  return <LegalPage doc={cookies} />;
}

export function PrivacidadEstatal() {
  return <LegalPage doc={privacidadEstatal} />;
}
